import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "@/lib/api";
import { getAnonId } from "@/lib/anonId";

const PING_DONE_KEY = "aluzyjna_visit_pinged_at";
const PING_TTL_MS = 60 * 60 * 1000; // re-ping at most once per hour per browser

export default function VisitorStats() {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        const anonId = getAnonId();
        // Ping at most once per hour per browser session (idempotent server-side anyway)
        let shouldPing = true;
        try {
            const last = parseInt(window.localStorage.getItem(PING_DONE_KEY) || "0", 10);
            if (last && Date.now() - last < PING_TTL_MS) shouldPing = false;
        } catch { /* ignore */ }

        const fetchStats = () =>
            api.get("/visits/stats")
                .then((r) => setStats(r.data))
                .catch(() => {});

        if (shouldPing) {
            api.post("/visits/ping", { anonymous_id: anonId })
                .then(() => {
                    try { window.localStorage.setItem(PING_DONE_KEY, String(Date.now())); } catch { /* ignore */ }
                    fetchStats();
                })
                .catch(fetchStats);
        } else {
            fetchStats();
        }
    }, []);

    if (!stats) return null;

    return (
        <div
            data-testid="visitor-stats"
            className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1 text-[11px] text-white/40 mt-4"
            title="Statystyki odwiedzin – liczone anonimowo, raz na przeglądarkę na dobę"
        >
            <span className="inline-flex items-center gap-1.5">
                <Users size={11} className="text-[#D4A537]/70" />
                <span className="uppercase tracking-wider">Odwiedziny</span>
            </span>
            <span data-testid="visits-today">
                Dziś: <span className="font-semibold text-white/60 tabular-nums">{stats.today}</span>
            </span>
            <span className="text-white/20">·</span>
            <span data-testid="visits-month">
                W tym miesiącu: <span className="font-semibold text-white/60 tabular-nums">{stats.this_month}</span>
            </span>
            <span className="text-white/20">·</span>
            <span data-testid="visits-total">
                Łącznie: <span className="font-semibold text-white/60 tabular-nums">{stats.total}</span>
            </span>
        </div>
    );
}
